import React, { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom';
import ripl from './ripllogo.png';

const Login = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    userid: "",
    pass: ""
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmission = () => {
    if (!values.userid || !values.pass) {
      setErrorMsg("Fill all fields");
      return;
    }
    setErrorMsg("");

    if (values.userid === 'admin' && values.pass === 'admin123') {
      setShowSuccess(true);
      // Wait for animation to complete before redirecting
      setTimeout(() => {
        navigate('/dashboard');
      }, 2000);
    }
    else {
      setErrorMsg("Wrong User ID or Password");
      return;
    }
  }

  return (
    <div className='min-h-screen relative flex items-center justify-center p-4 overflow-hidden'>
      {/* Animated Background */}
      <div className='absolute inset-0 bg-gradient-to-br from-blue-50 to-slate-100 animate-gradient'></div>
      
      {/* Animated Circles */}
      <div className='absolute top-0 -left-4 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob'></div>
      <div className='absolute top-0 -right-4 w-72 h-72 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000'></div>
      <div className='absolute -bottom-8 left-20 w-72 h-72 bg-pink-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000'></div>

      {/* Success Overlay */}
      {showSuccess && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 animate-fade-in'>
          <div className='bg-white rounded-2xl p-8 text-center transform transition-all duration-500 animate-scale-in'>
            <div className='w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4'>
              <svg className="w-8 h-8 text-green-500 animate-checkmark" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className='text-2xl font-bold text-gray-800 mb-2'>Login Successful!</h2>
            <p className='text-gray-600'>Redirecting to dashboard...</p>
          </div>
        </div>
      )}

      {/* Login Card */}
      <div className='w-full max-w-md relative'>
        <div className='bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:scale-[1.02]'>
          {/* Header Section */}
          <div className='bg-gradient-to-r from-blue-900 to-blue-800 p-8 text-center'>
            <div className='bg-white rounded-xl p-4 inline-block mb-4 transform transition-all duration-300 hover:scale-105'>
              <img className='mx-auto' src={ripl} width={180} alt="RIPL Logo" />
            </div>
            <h1 className='text-2xl font-bold text-white'>Welcome Back</h1>
            <p className='text-blue-100 mt-2'>Please sign in to continue</p>
          </div>

          {/* Form Section */}
          <div className='p-8'>
            <div className='space-y-6'>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-2'>Login ID</label>
                <div className='relative'>
                  <input
                    type="text"
                    placeholder='Enter your login ID'
                    className='w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200'
                    onChange={(event) =>
                      setValues((prev) => ({ ...prev, userid: event.target.value }))
                    }
                  />
                </div>
              </div>

              <div>
                <label className='block text-sm font-medium text-gray-700 mb-2'>Password</label>
                <div className='relative'>
                  <input
                    type="password"
                    placeholder='Enter your password'
                    className='w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors duration-200'
                    onChange={(event) =>
                      setValues((prev) => ({ ...prev, pass: event.target.value }))
                    }
                  />
                </div>
              </div>

              {errorMsg && (
                <div className='bg-red-50 border-l-4 border-red-500 p-4 rounded animate-fade-in'>
                  <p className='text-red-700 text-sm'>{errorMsg}</p>
                </div>
              )}

              <button
                onClick={handleSubmission}
                className='w-full bg-gradient-to-r from-blue-900 to-blue-800 text-white font-semibold py-3 px-4 rounded-lg hover:from-blue-800 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 transform hover:scale-[1.02]'
              >
                Sign In
              </button>

              <div className='text-center'>
                <button className='text-sm text-gray-600 hover:text-blue-900 transition-colors duration-200'>
                  Forgot your password? Contact administrator
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add the required Tailwind CSS animations */}
      <style jsx>{`
        @keyframes gradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        @keyframes blob {
          0% { transform: translate(0px, 0px) scale(1); }
          33% { transform: translate(30px, -50px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
          100% { transform: translate(0px, 0px) scale(1); }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scale-in {
          from { transform: scale(0.9); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
        @keyframes checkmark {
          0% { transform: scale(0); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
        .animate-gradient {
          background-size: 400% 400%;
          animation: gradient 15s ease infinite;
        }
        .animate-blob {
          animation: blob 7s infinite;
        }
        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }
        .animate-scale-in {
          animation: scale-in 0.5s ease-out;
        }
        .animate-checkmark {
          animation: checkmark 0.5s ease-out forwards;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  )
}

export default Login
